import { useMutation } from '@tanstack/react-query';

import { TRANSACTION_TYPES } from '@autopass-web/domain';

import { setDpassSignupRecord } from '../stores/use-dpass-signup-record';
import { dpassAxiosInstance } from './client';

import type { PaymentMethodType } from '@autopass-web/types';

interface CreateDpassMembershipRequest {
  email: string;
  from?: string;
}

const createDpassMembership = ({
  email,
  from,
}: CreateDpassMembershipRequest) => {
  return dpassAxiosInstance.post('/v2/auth/init', { email, from });
};

const useCreateDpassMembership = () => {
  const mutation = useMutation({
    mutationFn: ({ email, from }: CreateDpassMembershipRequest) => {
      return createDpassMembership({ email, from });
    },
    onSuccess(_, params) {
      setDpassSignupRecord({ email: params.email, from: params.from });
    },
  });

  return {
    createDpassMembership: mutation.mutateAsync,
    createDpassMembershipLoading: mutation.isPending,
  };
};

// FIXME: 暫時關閉 DPass 註冊入口（checkbox、提醒視窗、建立會員 API 都會一併停用）。
// 要恢復功能只需將這個開關改回 true，不要在 UI 端另外加條件。
const DPASS_SIGNUP_ENABLED = true;

const TYPE_DEFAULT_OPTION: Record<string, boolean | undefined> = {
  [TRANSACTION_TYPES.PARKING_PAYMENT]: false,
  [TRANSACTION_TYPES.CHARGING]: false,
};

const getDpassSignupDefaultValue = ({
  transactionType,
  paymentMethod,
}: {
  transactionType: string;
  paymentMethod: PaymentMethodType | null;
}) => {
  if (!DPASS_SIGNUP_ENABLED) return undefined;

  const defaultOption = TYPE_DEFAULT_OPTION?.[transactionType];

  // Apple Pay 的 payment sheet 啟動後無法插入額外的同意步驟, 所以這類付款不顯示 DPass 註冊
  const supportsInlineConsent = paymentMethod !== 'apple_pay';

  if (!supportsInlineConsent) return undefined;

  return defaultOption;
};

export { getDpassSignupDefaultValue, useCreateDpassMembership };
